import * as types from './types'

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null,
}

const initialState = {
	mismatch: data,
	mismatchXsl: data,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.GET_MISMATCH_ACTION:
			return { ...state, mismatch: { ...data, loading: true } }

		case types.GET_MISMATCH_ACTION_DONE:
			return { ...state, mismatch: { ...data, data: payload, success: true } }

		case types.GET_MISMATCH_ACTION_FAIL:
			return { ...state, mismatch: { ...data, failed: true } }


		case types.GET_MISMATCH_XSL_ACTION:
			return { ...state, mismatchXsl: { ...data, loading: true } }

		case types.GET_MISMATCH_XSL_ACTION_DONE:
			return { ...state, mismatchXsl: { ...data, data: payload, success: true } }

		case types.GET_MISMATCH_XSL_ACTION_FAIL:
			return { ...state, mismatchXsl: { ...data, failed: true } }

		default:
			return state
	}
}
